export var NotificationsRoutes;
(function (NotificationsRoutes) {
    NotificationsRoutes["NOTIFICATIONS"] = "notifications";
})(NotificationsRoutes || (NotificationsRoutes = {}));
